import { scrolling } from 'assets/utilities';

import './headerPromo.scss';

const SELECTOR_EL = '.js-headerPromo';
const SELECTOR_CLOSE = '.js-headerPromoClose';

const onCloseClick = function onHeaderPromoCloseClick() {
  const el = document.querySelector(SELECTOR_EL);
  if (!el) {
    return;
  }

  const elClose = document.querySelector(SELECTOR_CLOSE);
  elClose.removeEventListener('click', onCloseClick);

  const startHeight = el.offsetHeight;
  el.style.height = `${startHeight}px`;
  setTimeout(() => {
    el.style.height = 0;
  }, 50);
  setTimeout(() => {
    el.parentNode.removeChild(el);
    scrolling.rebuildCache();
  }, 450);
};

const hide = function hideHeaderPromo() {
  const el = document.querySelector(SELECTOR_EL);
  if (!el) {
    return;
  }

  const elClose = document.querySelector(SELECTOR_CLOSE);
  elClose.removeEventListener('click', onCloseClick);
  el.parentNode.removeChild(el);
  scrolling.rebuildCache();
};

const bind = function bindHeaderPromo() {
  const elClose = document.querySelector(SELECTOR_CLOSE);
  if (!elClose) {
    return;
  }

  elClose.addEventListener('click', onCloseClick);
};

const init = function initHeaderPromo() {
  bind();
};

export default {
  close: onCloseClick,
  hide,
  init,
};
